export enum State {
  Positive = 'positive',
  Negative = 'negative',
  Highlight = 'highlight',
}
